import { Box, Text } from "@repo/ui/core";
import type { ReactNode } from "react";
import { BackgroundPaths } from "./BackgroundPaths";
import { ParkingLotDrawer } from "./ParkingLotDrawer";
import { SlideNav } from "./SlideNav";

type Props = {
  colorFrom: string;
  colorTo: string;
  onExit: () => void;
  children: ReactNode;
};

export function SlideShell({ colorFrom, colorTo, onExit, children }: Props) {
  return (
    <Box
      pos="fixed"
      top={0}
      left={0}
      w="100vw"
      h="100vh"
      style={{
        background: "var(--mantine-color-dark-9)",
        zIndex: 1000,
        overflow: "hidden",
      }}
    >
      <BackgroundPaths colorFrom={colorFrom} colorTo={colorTo} />
      <Box
        pos="relative"
        w="100%"
        h="100%"
        style={{
          display: "flex",
          flexDirection: "column",
          zIndex: 1,
        }}
      >
        <Box
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "clamp(0.75rem, 1.5vw, 2rem)",
          }}
        >
          {children}
        </Box>
        <Box ta="center" px="md" pb="md">
          <Text c="dimmed" size="sm" opacity={0.6}>
            CONFIDENTIAL: Any disclosure, use, reproduction, or distribution of
            this information without the express consent of Null Autos (in
            writing) is strictly prohibited.
          </Text>
        </Box>
        <SlideNav onExit={onExit} />
      </Box>
      <ParkingLotDrawer />
    </Box>
  );
}
